/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_Team_ManagementInputs */

const en_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open team management`)
};

const fr_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir la gestion d'équipe`)
};

const de_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offenes Teammanagement`)
};

const it_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione aperta del team`)
};

const ru_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытое управление командой`)
};

const es_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de equipos abiertos`)
};

const zh_cn2_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开放式团队管理`)
};

const ja_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オープンチーム管理`)
};

const hi_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खुली टीम प्रबंधन`)
};

const pt_pt2_open_team_management = /** @type {(inputs: Open_Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão de equipe aberta`)
};

/**
* | output |
* | --- |
* | "Open team management" |
*
* @param {Open_Team_ManagementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_team_management = /** @type {((inputs?: Open_Team_ManagementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Team_ManagementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_open_team_management(inputs)
	if (locale === "de") return de_open_team_management(inputs)
	if (locale === "it") return it_open_team_management(inputs)
	if (locale === "ru") return ru_open_team_management(inputs)
	if (locale === "es") return es_open_team_management(inputs)
	if (locale === "zh-CN") return zh_cn2_open_team_management(inputs)
	if (locale === "ja") return ja_open_team_management(inputs)
	if (locale === "hi") return hi_open_team_management(inputs)
	if (locale === "pt-PT") return pt_pt2_open_team_management(inputs)
	return en_open_team_management(inputs)
});